import React, { useState } from 'react';
import NavbarQuoteDetailStyle from './style';
import { useSelector } from 'react-redux';
import { quoteDetailSelector } from 'src/redux/selectors/quoteDetailSelector';
import ModalComponent from 'src/components/modalCustom';
import { routerQuoteDetailData } from 'src/const/enum';
import { Link, useLocation } from 'react-router-dom';
import CopyLinkVersion from 'src/components/copyLinkVersion';
import icons from 'src/assets/icon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faShareNodes } from '@fortawesome/free-solid-svg-icons';
import { ENV } from 'src/const/evn';
import { Button } from 'antd';
import YourMasterComponent from 'src/components/yourMaster';
import { itinerarySelector } from 'src/redux/selectors/itinerarySelector';
import CartWrap from 'src/components/cartWrap';
import AvatarConsultant from 'src/components/avatarConsultant';
import ItineraryScrollComponent from 'src/components/itineraryLinkCroll';
import { apiDownLoadPDF } from 'src/api/apiDownloadPDF';
import { toast } from 'react-toastify';
import useIsPdfPage from 'src/hooks/useIsPdfPage';
import { multipleQuotesSelector } from 'src/redux/selectors/multipleQuotesSelector';
import { formatCurrency } from 'src/const/contain';

interface NavbarQuoteDetailProps {
    isPreview: boolean;
}

const NavbarQuoteDetail: React.FC<NavbarQuoteDetailProps> = ({ isPreview }) => {
    const location = useLocation();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isLoadingDownloadPdf, setIsLoadingDownloadPdf] =
        useState<boolean>(false);

    const queryParams = new URLSearchParams(location.search);
    const quoteIdQuery = queryParams.get('id') || '';
    const queryParamsMultipleQuotes = queryParams.get('multipleQuotes');
    const isPdfPage = useIsPdfPage();

    const { ids: quotesArray = []} = useSelector(
        multipleQuotesSelector,
    );

    const {
        id: quoteId = '',
        resConsultant,
        price,
        isEvent,
        version,
    } = useSelector(quoteDetailSelector);

    const { totalDeposit } = price;
    const { id: versionId } = version;

    const { atAGlance } = useSelector(itinerarySelector);
    const { name: nameConsultant, jobTitle, companyName } = resConsultant;
    const lastName = nameConsultant?.split(' ').slice(0, -1).join(' ');

    const handleShowModal = () => {
        setIsModalVisible(true);
    };

    const handleCloseModal = () => {
        setIsModalVisible(false);
    };

    const pathName = (path: string) => {
        return `/${
            isCheckPathName('quoteDetail') ? 'quoteDetail' : 'multipleQuotes'
        }/${path}?id=${quoteIdQuery}${
            queryParamsMultipleQuotes
                ? `&multipleQuotes=${queryParamsMultipleQuotes}`
                : ''
        }`;
    };

    const isCheckPathName = (path: string) => {
        return location.pathname.includes(path);
    };

    const handleDownloadPdf = async () => {
        try {
            setIsLoadingDownloadPdf(true);
            const response = await apiDownLoadPDF({
                quoteRef: quoteId,
                version: version?.version,
                url: `${ENV.PUBLIC_ENV}/download-pdf?id=${quoteId}`,
                format: 'A2',
            });

            if (
                response &&
                response instanceof Blob &&
                response.type === 'application/pdf'
            ) {
                const url = window.URL.createObjectURL(response);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = `Quote${quoteId}.pdf`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                toast.success('PDF downloaded successfully!');
                setIsLoadingDownloadPdf(false);
            } else {
                toast.error('Failed to download PDF');
                setIsLoadingDownloadPdf(false);
            }
        } catch (error) {
            toast.error('Failed to download PDF');
            setIsLoadingDownloadPdf(false);
        }
    };

    const renderConsultant = () => (
        <div className="card">
            <div className="box-consultant">
                <div className="consultant">
                    <p>“I’m {lastName} and I’ll be looking after your trip.”</p>
                    <p className="golfer">{nameConsultant}</p>
                    {jobTitle && <p>{jobTitle}</p>}
                    {companyName && (
                        <p>
                            {companyName
                                ?.replace('Golf ', '')
                                ?.replace('plus', '+')}
                        </p>
                    )}
                </div>
                <AvatarConsultant />
            </div>
            <a
                href={`${ENV.URL_PAYMENT}/quotes/QV${quoteId}`}
                className="btn-pay"
                target="_blank"
                rel="noreferrer"
            >
                Secure Quote Now for £{formatCurrency(totalDeposit)}
            </a>
        </div>
    );

    const renderBoxNav = () => (
        <div className="card">
            <ul className="navbar">
                {routerQuoteDetailData.map((item) => (
                    <li key={item.path}>
                        <Link
                            to={pathName(item.path)}
                            className={
                                isCheckPathName(item.path) ? 'active' : ''
                            }
                        >
                            {isCheckPathName(item.path) && (
                                <img
                                    alt=""
                                    className="arrowLeft"
                                    src={icons.arrowLeft}
                                />
                            )}
                            {item.title}
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );

    const renderMiniCart = () => (
        <div className="card mini-basket">
            <div className="reference">Quote reference: {quoteId}</div>
            <CartWrap />
        </div>
    );

    const renderShareQuote = () => (
        <>
            <Button
                type="primary"
                className="btnShare"
                ghost
                onClick={handleShowModal}
            >
                Share Quote <FontAwesomeIcon icon={faShareNodes} />
            </Button>
            <ModalComponent
                width={500}
                visible={isModalVisible}
                onClose={handleCloseModal}
                title={'Share your quote with your fellow golfers'}
                content={<CopyLinkVersion onDoneCopy={handleCloseModal} />}
            />
        </>
    );

    const renderDownloadPdf = () => (
        <Button
            type="primary"
            className="btnShare"
            ghost
            onClick={handleDownloadPdf}
            style={{ marginBottom: '1rem' }}
            loading={isLoadingDownloadPdf}
        >
            Download PDF <FontAwesomeIcon icon={faDownload} />
        </Button>
    );

    return (
        <NavbarQuoteDetailStyle>
            {renderConsultant()}
            {!isPdfPage && renderBoxNav()}
            {renderMiniCart()}
            {isEvent && <YourMasterComponent atAGlance={atAGlance} />}
            {!isPdfPage && (
                <>
                    {isEvent && isCheckPathName('itineraryInDetail') && (
                        <ItineraryScrollComponent />
                    )}
                    {versionId &&
                        quotesArray.length === 0 &&
                        renderDownloadPdf()}
                    {versionId &&
                        !queryParamsMultipleQuotes &&
                        renderShareQuote()}
                </>
            )}
        </NavbarQuoteDetailStyle>
    );
};

export default NavbarQuoteDetail;
